import { validateResponse } from './validateResponse';
/**
 * 공통 API 응답을 처리하고 결과값을 반환합니다.
 *
 * @template T
 * @param {() => Promise<{
 *   data: {
 *     resultCd: string,
 *     resultMsg: string,
 *     result: T
 *   }
 * }>} apiCall API 호출 함수
 * @param {string} errorPrefix 에러 로그 출력용 함수명
 *
 * @returns {Promise<T>} API 결과 데이터
 *
 * @throws {Error}
 * 응답 결과 코드가 정상이 아니거나 API 호출 중 오류가 발생한 경우
 */
export async function executeApi(apiCall, errorPrefix) {
  try {
    const {
      data: { resultCd, result, resultMsg },
    } = await apiCall();

    validateResponse(resultCd, resultMsg);

    return result;
  } catch (error) {
    console.error(`[${errorPrefix} Error : ${error}]`);
    throw error;
  }
}
